<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', {'client':contact.client_id})">Udziałowcy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('contacts.edit', {'client':contact.client_id, 'contact':contact.id})">{{ contact.first_name }} {{ contact.last_name }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('sharer-history', {'contact':contact.id})">Historia</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowy wpis
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <select-input class="pr-6 pb-6 w-1/2" v-model="form.year" :error="form.errors.year" label="Rok">
              <option v-for="year in years">{{ year }}</option>
            </select-input>

            <span class="w-full pb-3">Rozliczanie podatku:</span>
            <shtax-checkbox class="pr-6 pb-6 w-1/2" v-model:checked.sync="form.is_main" :error="form.errors.is_main" :checked="form.is_main" :disabled="form.is_ryczalt" label="Zasady ogólne" />
            <shtax-checkbox class="pl-3 pr-6 pb-10 w-1/2" v-model:checked.sync="form.is_ryczalt" :error="form.errors.is_ryczalt" :checked="form.is_ryczalt" :disabled="form.is_main" label="Podatek zryczałtowany" />

            <span class="w-full pb-3">Podatek dochodowy - zasady ogólne</span>
            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_main_standard" :error="form.errors.is_main_standard" :checked="form.is_main_standard" :disabled="!form.is_main || form.is_liniowy || form.is_brak_wolnej" label="Standardowe stawki podatkowe" />
            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_brak_wolnej" :error="form.errors.is_brak_wolnej" :checked="form.is_brak_wolnej" :disabled="!form.is_main || form.is_main_standard || form.is_liniowy" label="Standardowe stawki podatkowe bez uwzględnienia kwoty wolnej od podatku" />
            <shtax-checkbox class="pr-6 pb-10 w-full" v-model:checked.sync="form.is_liniowy" :error="form.errors.is_liniowy" :checked="form.is_liniowy" :disabled="!form.is_main || form.is_main_standard || form.is_brak_wolnej" label="Podatek liniowy bez kwoty wolnej od podatku" />

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.pit_kwartalny" :error="form.errors.pit_kwartalny" :checked="form.pit_kwartalny" label="Zaliczki na podatek płacone kwartalnie" />
            <shtax-checkbox class="pr-6 w-full" v-model:checked.sync="form.rozliczenie_wspolne" :error="form.errors.rozliczenie_wspolne" :checked="form.rozliczenie_wspolne" label="Rozliczenie roczne razem ze współmałżonkiem" />
            <shtax-checkbox class="mt-6 pr-6 pb-6 w-full lg:w-2/3" v-model:checked.sync="form.is_kwota_upr" :error="form.errors.is_kwota_upr" :checked="form.is_kwota_upr" label="Zaliczki na podatek w stałej kwocie (metoda uproszczona)" />
            <text-input v-model="form.kwota_upr" :error="form.errors.kwota_upr" class="pr-6 pb-6 lg:pb-0 w-full lg:w-1/3" label="Kwota" type="number" step="0.01" :disabled="!form.is_kwota_upr" />
            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.has_ulgi" :error="form.errors.has_ulgi" :checked="form.has_ulgi" label="Współmałżonek korzysta z odliczeń uwzględnianych w PIT/0 lub PIT/D" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-shtax" type="submit">Dodaj wpis</loading-button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import SelectInput from '@/Shared/SelectInput'
import ShtaxRadio from '@/ShtaxComponents/Radio'

export default {
  metaInfo() {
    return {
      title: 'Nowy wpis historii udziałowca',
    }
  },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    SelectInput,
    ShtaxRadio
  },
  layout: Layout,
  props: {
    contact: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        year: new Date().getFullYear(),
        is_main: false,
        is_ryczalt: false,
        is_main_standard: false,
        is_brak_wolnej: false,
        is_liniowy: false,
        pit_kwartalny: false,
        rozliczenie_wspolne: false,
        is_kwota_upr: false,
        kwota_upr: "0.00",
        has_ulgi: false
      }),
      year: new Date().getFullYear()
    }
  },

  computed: {
    years: function () {
      return [ this.year-1, this.year, this.year+1]
    }
  },

  methods: {
    store() {
      this.form.post(this.route('sharer-history.store', this.contact.id))
    },
  },

}
</script>
